/**
 * 计算内容大小
 * @param value
 * @return {number}
 */
export function byteCounter(value) {
  value = value.replace(/\r\n/g, '\n');
  return new Blob([value]).size;
}

/**
 * base64编码
 * @param value
 * @return {string}
 */
export function base64encode(value) {
  return btoa(unescape(encodeURIComponent(value)));
}

/**
 * base64解码
 * first base64 and then utf-8
 * @param value
 * @return {string}
 */
export function base64decode(value) {
  return decodeURIComponent(escape(atob(value)));
}

/**
 * base64解码
 * only base 64
 * @param value
 * @return {string}
 */
// export function base64decode(value) {
//   return atob(value);
// }

/**
 * base64之前最大16kb
 * @type {number}
 */
export const originMaxSize = 16384;
/**
 * base64之后最大21790.3b
 * 编码和解码之间存在个4/3转换
 * @type {number}
 */
export const encodeMaxSize = 21790;

/**
 * 校验输入的内容是否为base64编码格式
 * @param value
 * @return {boolean}
 */
export function checkIsBase64OrNot(value) {
  const rule = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)?$/;
  if (!rule.test(value)) {
    console.log(value, 'error reg');
    return false;
  }
  try {
    base64decode(value);
  } catch (e) {
    return false;
  }
  return true;
}



// WEBPACK FOOTER //
// ./src/common/byteCounter.js